// Module
var code = `<breadcrumbs></breadcrumbs>

<section id="risk-categories" class="box">
  <sub-header header="'List of risk categories'"></sub-header>

  <table class="risk-categories__table table table-hover table-style"
         ng-if="\$ctrl.riskCategories">
    <thead>
    <tr>
      <th class="no-column-header">No</th>
      <th>Category name</th>
      <th>Percentage</th>
      <th>Individual</th>
      <th ng-if="\$ctrl.corporateCustomerEnabled">Corporate</th>
      <th></th>
    </tr>
    </thead>
    <tbody class="tbody">
    <tr ng-repeat="item in \$ctrl.riskCategories">
      <td>
        {{ \$index+1+'.' }}
      </td>
      <td class="risk-categories__category-name">{{ item.name }}</td>
      <td>
        <glue-container append="'%'" class="risk-categories__input-container">
          <input type="number"
                 required
                 ng-model="item.weightPercentage"
                 min="1"
                 step="1"
                 ng-change="\$ctrl.refreshDisplayedPercentages(item.id, item.weightPercentage)"/>
        </glue-container>
      </td>
      <td>{{ item.individualPercentage ? item.individualPercentage + '%' : '-' }}</td>
      <td ng-if="\$ctrl.corporateCustomerEnabled">{{ item.corporatePercentage ? item.corporatePercentage + '%' : '-' }}</td>
      <td>
        <div class="buttons">
          <a class="risk-categories__open-button btn btn-primary"
             ng-href="#!/admin/compliance/risk/categories/{{item.id}}">
            Open
          </a>
          <button class="btn btn-danger"
                  command-access="DeleteRiskCategory"
                  ng-click="\$ctrl.removeCategory(item.id)">
            Delete
          </button>
        </div>
      </td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td><strong>Total</strong></td>
      <td></td>
      <td></td>
      <td>{{ (\$ctrl.totalIndividualPercentage + '%') || '-' }}</td>
      <td ng-if="\$ctrl.corporateCustomerEnabled">{{ \$ctrl.totalCorporatePercentage ? \$ctrl.totalCorporatePercentage + '%' : '-' }}</td>
      <td></td>
    </tr>
    </tfoot>
  </table>
  <div ng-if="!\$ctrl.riskCategories || !\$ctrl.riskCategories.length"
       class="centered-gray-information-message">
    <span>No risk categories found.</span>
  </div>

  <div class="buttons">
    <button class="btn btn-warning"
            ng-click="\$ctrl.goBack()">
      Back
    </button>
    <button class="btn btn-success"
            ng-click="\$ctrl.savePercentages()">
      Save percentages
    </button>
    <a class="sub-header__create-button btn btn-primary"
       command-access="CreateRiskCategory"
       ng-href="#!/admin/compliance/risk/categories/create">
      Create new
    </a>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/risk-profiling/risk-categories/risk-categories.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;